import ListSPKPermintaanPrelim from './ListSPKPermintaanPrelim';

export default ListSPKPermintaanPrelim;
